export default {
  props: {
    stepData: {
      type: Object,
      default: () => {},
    },
    orderData: {
      type: Object,
      default: () => {},
    },
    cart: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      stepLanguageKey: "",
    };
  },
  computed: {
    canComplete() {
      return false;
    },
    completionConditionText() {
      if (this.canComplete) {
        return "";
      }

      return this.tu(
        "ecommerce.checkout.steps.genericCompletionConditionText",
        { step: this.t(`ecommerce.checkout.${this.stepLanguageKey}.stepTitle`) }
      );
    },
  },
  watch: {
    completionConditionText: {
      handler(newVal) {
        this.stepData.completionConditionText = newVal;
      },
      immediate: true,
    },
  },
};
